const threeDots = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.71429 9.99972C5.71429 11.5777 4.4351 12.8569 2.85714 12.8569C1.27919 12.8569 0 11.5777 0 9.99972C0 8.42176 1.27919 7.14258 2.85714 7.14258C4.4351 7.14258 5.71429 8.42176 5.71429 9.99972ZM12.8571 9.99972C12.8571 11.5777 11.578 12.8569 10 12.8569C8.42204 12.8569 7.14286 11.5777 7.14286 9.99972C7.14286 8.42176 8.42204 7.14258 10 7.14258C11.578 7.14258 12.8571 8.42176 12.8571 9.99972ZM17.1429 12.8569C18.7209 12.8569 20 11.5777 20 9.99972C20 8.42176 18.7209 7.14258 17.1429 7.14258C15.5649 7.14258 14.2857 8.42176 14.2857 9.99972C14.2857 11.5777 15.5649 12.8569 17.1429 12.8569Z" fill="#232323"/>
</svg>`

export const oneTimeInvestIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="25" viewBox="0 0 26 25" fill="none">
  <path d="M23.3929 13.2953V22.0534C23.3929 23.1283 22.5217 23.9996 21.4468 23.9996H3.44515C2.37033 23.9996 1.49902 23.1283 1.49902 22.0534V10.3759C1.49902 9.30106 2.37033 8.42969 3.44515 8.42969H14.0765" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6.17015 16.0098C5.90144 16.0098 5.68359 16.2276 5.68359 16.4963C5.68359 16.765 5.90144 16.9829 6.17015 16.9829" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6.1709 16.0098C6.43962 16.0098 6.65746 16.2276 6.65746 16.4963C6.65746 16.765 6.43962 16.9829 6.1709 16.9829" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M18.7219 16.0098C18.4532 16.0098 18.2354 16.2276 18.2354 16.4963C18.2354 16.765 18.4532 16.9829 18.7219 16.9829" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M18.7227 16.0098C18.9914 16.0098 19.2092 16.2276 19.2092 16.4963C19.2092 16.765 18.9914 16.9829 18.7227 16.9829" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12.4463 13.7852C13.7899 13.7852 14.879 14.8744 14.879 16.218C14.879 17.5616 13.7899 18.6508 12.4463 18.6508C11.1028 18.6508 10.0137 17.5616 10.0137 16.218C10.0137 14.8744 11.1028 13.7852 12.4463 13.7852Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M20.6064 10.7312V1" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M16.7129 6.83789L20.6051 10.7304L24.4974 6.83789" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

export const startSIPIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
  <path d="M17.0059 0C17.3935 0.000207523 17.708 0.314502 17.708 0.702148V2.57422H19.5801C20.2212 2.57432 20.8357 2.82971 21.2891 3.2832C21.7423 3.73657 21.9979 4.35087 21.998 4.99219V19.582C21.9979 20.2232 21.7423 20.8377 21.2891 21.291C20.8357 21.7443 20.2213 21.9999 19.5801 22H2.41699C1.77581 21.9998 1.16128 21.7442 0.708008 21.291C0.254673 20.8377 -0.000785148 20.2231 -0.000976562 19.582V4.99219C-0.000851991 4.35103 0.254754 3.73661 0.708008 3.2832C1.16134 2.82986 1.77588 2.57442 2.41699 2.57422H4.29004V0.702148C4.29004 0.314374 4.60442 0 4.99219 0C5.3799 7.10119e-05 5.69434 0.314418 5.69434 0.702148V2.57422H16.3037V0.702148C16.3037 0.314374 16.6181 0 17.0059 0ZM2.41699 3.97852C2.14846 3.97871 1.89116 4.08558 1.70117 4.27539C1.5111 4.46549 1.40344 4.72339 1.40332 4.99219V19.582C1.40351 19.8508 1.51123 20.1089 1.70117 20.2988C1.89121 20.4886 2.14861 20.5955 2.41699 20.5957H19.5801C19.8488 20.5956 20.1068 20.4888 20.2969 20.2988C20.4868 20.1088 20.5936 19.8507 20.5938 19.582V4.99219C20.5936 4.72348 20.4869 4.46555 20.2969 4.27539C20.1069 4.08537 19.8489 3.97861 19.5801 3.97852H17.708V5.85059C17.708 6.23823 17.3935 6.55253 17.0059 6.55273C16.6181 6.55273 16.3037 6.23836 16.3037 5.85059V3.97852H5.69434V5.85059C5.69434 6.23832 5.3799 6.55266 4.99219 6.55273C4.60442 6.55273 4.29004 6.23836 4.29004 5.85059V3.97852H2.41699ZM10.999 6.86328C11.3867 6.86343 11.7012 7.17775 11.7012 7.56543V15.3115L13.9346 13.0791C14.2087 12.805 14.6526 12.8051 14.9268 13.0791C15.2009 13.3533 15.2009 13.7971 14.9268 14.0713L11.4951 17.5049C11.3636 17.6363 11.1849 17.7099 10.999 17.71C10.8131 17.71 10.6345 17.6361 10.5029 17.5049L7.07031 14.0713C6.79613 13.7971 6.79614 13.3533 7.07031 13.0791C7.34449 12.8049 7.78832 12.8049 8.0625 13.0791L10.2969 15.3135V7.56543C10.2969 7.17766 10.6113 6.86328 10.999 6.86328Z" fill="black"/>
</svg>`

export const oneTimeWithdrawIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="25" viewBox="0 0 26 25" fill="none">
  <path d="M23.3939 13.2938V22.0527C23.3939 23.1277 22.5226 23.9991 21.4476 23.9991H3.44435C2.36944 23.9991 1.49805 23.1277 1.49805 22.0527V10.3742C1.49805 9.29918 2.36944 8.42773 3.44435 8.42773H15.1222" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6.1702 16.0059C5.90146 16.0059 5.68359 16.2237 5.68359 16.4925C5.68359 16.7612 5.90146 16.9791 6.1702 16.9791" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6.1709 16.0059C6.43964 16.0059 6.6575 16.2237 6.6575 16.4925C6.6575 16.7612 6.43964 16.9791 6.1709 16.9791" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M18.7229 16.0059C18.4542 16.0059 18.2363 16.2237 18.2363 16.4925C18.2363 16.7612 18.4542 16.9791 18.7229 16.9791" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M18.7236 16.0059C18.9924 16.0059 19.2102 16.2237 19.2102 16.4925C19.2102 16.7612 18.9924 16.9791 18.7236 16.9791" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12.4465 13.7812C13.7902 13.7812 14.8794 14.8705 14.8794 16.2143C14.8794 17.5581 13.7902 18.6473 12.4465 18.6473C11.1029 18.6473 10.0137 17.5581 10.0137 16.2143C10.0137 14.8705 11.1029 13.7812 12.4465 13.7812Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M20.6055 0.998377L20.6055 10.7305" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M24.499 4.89258L20.6064 0.99974L16.7138 4.89258" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

export const startSWPIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
  <path d="M17.0059 0C17.3935 0.000207523 17.708 0.314502 17.708 0.702148V2.57422H19.5801C20.2212 2.57432 20.8357 2.82971 21.2891 3.2832C21.7423 3.73657 21.9979 4.35087 21.998 4.99219V19.582C21.9979 20.2232 21.7423 20.8377 21.2891 21.291C20.8357 21.7443 20.2213 21.9999 19.5801 22H2.41699C1.77581 21.9998 1.16128 21.7442 0.708008 21.291C0.254673 20.8377 -0.000785148 20.2231 -0.000976562 19.582V4.99219C-0.000851991 4.35103 0.254754 3.73661 0.708008 3.2832C1.16134 2.82986 1.77588 2.57442 2.41699 2.57422H4.29004V0.702148C4.29004 0.314374 4.60442 0 4.99219 0C5.37991 5.55534e-05 5.69434 0.314408 5.69434 0.702148V2.57422H16.3037V0.702148C16.3037 0.314374 16.6181 0 17.0059 0ZM2.41699 3.97852C2.14846 3.97871 1.89116 4.08558 1.70117 4.27539C1.5111 4.46549 1.40344 4.72339 1.40332 4.99219V19.582C1.40351 19.8508 1.51123 20.1089 1.70117 20.2988C1.89121 20.4886 2.14861 20.5955 2.41699 20.5957H19.5801C19.8488 20.5956 20.1068 20.4888 20.2969 20.2988C20.4868 20.1088 20.5936 19.8507 20.5938 19.582V4.99219C20.5936 4.72348 20.4869 4.46555 20.2969 4.27539C20.1069 4.08537 19.8489 3.97861 19.5801 3.97852H17.708V5.85059C17.708 6.23823 17.3935 6.55253 17.0059 6.55273C16.6181 6.55273 16.3037 6.23836 16.3037 5.85059V3.97852H5.69434V5.85059C5.69434 6.23833 5.37991 6.55268 4.99219 6.55273C4.60442 6.55273 4.29004 6.23836 4.29004 5.85059V3.97852H2.41699ZM10.998 6.86426C11.1841 6.86426 11.3635 6.93791 11.4951 7.06934L14.9277 10.5029C15.2016 10.7771 15.2016 11.221 14.9277 11.4951C14.6536 11.7693 14.2087 11.7693 13.9346 11.4951L11.7012 9.26172V17.0088C11.7012 17.3965 11.3867 17.7108 10.999 17.7109C10.6113 17.7109 10.2969 17.3966 10.2969 17.0088V9.26172L8.06348 11.4951C7.78935 11.7693 7.3445 11.7692 7.07031 11.4951C6.79638 11.2209 6.79633 10.7771 7.07031 10.5029L10.502 7.06934C10.6334 6.93792 10.8122 6.86446 10.998 6.86426Z" fill="black"/>
</svg>`

export const transferIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
  <path d="M15.8574 19.0539L19.5181 15.3931L15.8574 11.7324" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6.14314 10.2687L2.48242 6.60798L6.14314 2.94727" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M2.48242 6.60742H17.5181" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M19.5181 15.3945H4.48242" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

export interface ButtonConfig {
  text?: string
  testLocator: string
}

export interface InvestmentExistsButtonConfig extends ButtonConfig {
  type: 'more-options' | 'withdraw' | 'invest'
  icon?: string
  isPrimary?: boolean
  width?: number
}

export interface InvestmentDoesNotExistButtonConfig extends ButtonConfig {
  type: 'one-time' | 'start-sip'
  isPrimary?: boolean
  width?: number
}

export interface InvestButtonConfig extends ButtonConfig {
  type: 'one-time' | 'start-sip'
  icon: string
}

export interface WithdrawButtonConfig extends ButtonConfig {
  type: 'one-time' | 'start-swp'
  icon: string
}

export interface MoreOptionsButtonConfig extends ButtonConfig {
  type: 'transfer'
  icon: string
}

export const investmentExistsButtons: InvestmentExistsButtonConfig[] = [
  // {
  //   type: 'more-options',
  //   icon: threeDots,
  //   isPrimary: false,
  //   width: 64,
  //   testLocator: 'MFL2_CTA_THREE_DOTS'
  // },
  {
    type: 'withdraw',
    text: 'Withdraw',
    isPrimary: false,
    testLocator: 'MFL2_CTA_WITHDRAW'
  },
  {
    type: 'invest',
    text: 'Invest',
    isPrimary: true,
    testLocator: 'MFL2_CTA_INVEST'
  }
]

export const investmentDoesNotExistButtons: InvestmentDoesNotExistButtonConfig[] = [
  {
    type: 'one-time',
    text: 'One-time',
    isPrimary: false,
    testLocator: 'MFL2_CTA_ONE_TIME'
  },
  {
    type: 'start-sip',
    text: 'Start SIP',
    isPrimary: true,
    testLocator: 'MFL2_CTA_SIP'
  }
]

export const investButtons: InvestButtonConfig[] = [
  {
    type: 'one-time',
    text: 'One-time',
    icon: oneTimeInvestIcon,
    testLocator: 'MFL2_BS_CTA_ONE_TIME'
  },
  {
    type: 'start-sip',
    text: 'Start SIP',
    icon: startSIPIcon,
    testLocator: 'MFL2_BS_CTA_SIP'
  }
]

export const withdrawButtons: WithdrawButtonConfig[] = [
  {
    type: 'one-time',
    text: 'One-time',
    icon: oneTimeWithdrawIcon,
    testLocator: 'MFL2_BS_CTA_SELL'
  }
  // {
  //   type: 'start-swp',
  //   text: 'Start SWP',
  //   icon: startSWPIcon,
  //   testLocator: 'MFL2_BS_CTA_SWP'
  // }
]

export const moreOptionsButtons: MoreOptionsButtonConfig[] = [
  {
    type: 'transfer',
    text: 'Transfer',
    icon: transferIcon,
    testLocator: 'MFL2_BS_CTA_TRANSFER'
  }
]
